import { FundingSource, FundingSourceDto } from '@/types';
import { createStore, withProps } from '@ngneat/elf';

export interface FundingSourceStateProps {
  response?: FundingSource;
  createDto: FundingSourceDto;
  updateDto: Partial<FundingSourceDto>;
}

export const fundingSourceInitialState: FundingSourceStateProps = {
  response: undefined,
  createDto: {
    code: '',
    description: '',
    bailleurDeFonds: false,
  },
  updateDto: {},
};

export const fundingSourceStateStore = createStore(
  { name: 'funding-source-state' },
  withProps<FundingSourceStateProps>({
    ...fundingSourceInitialState,
  })
);
